import React from 'react'
import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import View from '../../../../../components/pdf/View'
import Text from '../../../../../components/pdf/Text'
import Image from '../../../../../components/pdf/Image'
import Grid, { Col } from '../../../../../components/pdf/Grid'
import Header from '../../_shared/Header'
import BarChart from '../../components/chats/BarChart'
import { getChartsData } from '../../_helpers/pdfHelpers'
import Separator from '../../../../../components/helpers/Separator'

const AvalAndares = ({ headerValues, item }) => {
  const chartData = getChartsData(item)

  const config = {
    data: chartData,
    height: 300,
    xField: 'label',
    yField: 'percentage',
    color: '#9999ff'
  }

  return (
    <View pageBreakAfter style={{ minHeight: '27cm', display: 'flex', flexDirection: 'column' }}>
      <Col>
        <Header headerValues={headerValues} category={item.category} />
      </Col>
      <Col style={{ padding: '2rem 0', border: '1px solid #333', margin: '-1px 0' }}>
        <Grid>
          <Col width="60%" gutter="1rem">
            {!!chartData.length && <BarChart {...config} />}
          </Col>
          <Col width="40%" gutter="1rem">
            <Table color="transparent" width="100%">
              {chartData.map((item, index) => {
                const length = chartData.length
                const isLast = index === length - 1
                return (
                  <>
                    <TableRow color="transparent">
                      <TableCol color="transparent" style={isLast && { borderTop: '1px solid #333' }}>
                        <Text semibold={!isLast} bold={isLast} size={12}>
                          {item.label}
                        </Text>
                      </TableCol>
                      <TableCol color="transparent" style={isLast && { borderTop: '1px solid #333' }}>
                        <Text semibold={!isLast} bold={isLast} size={12} align="center">
                          {item.percentage}%
                        </Text>
                      </TableCol>
                    </TableRow>
                  </>
                )
              })}
            </Table>
          </Col>
        </Grid>
      </Col>
      <Col>
        <Table width="100%" useFontBaseColor>
          <TableRow useFontBaseColor>
            <TableCol colSpan={4} useFontBaseColor>
              <Text semibold>As perguntas serão respondidas com os valores:</Text>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor>
            <TableCol colSpan={4} useFontBaseColor>
              <Grid justify="space-evenly">
                <Text semibold>Atende totalmente = 3</Text>
                <Text semibold>Atende parcialmente = 2</Text>
                <Text semibold>Não atende = 1</Text>
                <Text semibold>Não se aplica = 0</Text>
              </Grid>
            </TableCol>
          </TableRow>
          {item?.medidasProtecaoEletronica && !!item?.medidasProtecaoEletronica?.replies.length && (
            <TableRow useFontBaseColor>
              <TableCol colSpan={3} bgColor="#000" useFontBaseColor>
                <Text color="#fff" semibold>
                  MEDIDAS DE PROTEÇÃO ELETRÔNICA
                </Text>
              </TableCol>
              <TableCol bgColor="#000" useFontBaseColor>
                <Text color="#fff" semibold align="center">
                  {item?.medidasProtecaoEletronica?.totalValue}
                </Text>
              </TableCol>
            </TableRow>
          )}
          {item?.medidasProtecaoEletronica?.replies.map((item, index) => {
            return (
              <>
                <TableRow useFontBaseColor>
                  <TableCol rowSpan={2} width="5%" useFontBaseColor>
                    <Text align="center">{item.questionNumber}</Text>
                  </TableCol>
                  <TableCol colSpan={2} useFontBaseColor>
                    <Text>{item.question}</Text>
                  </TableCol>
                  <TableCol useFontBaseColor>
                    <Text align="center">{item.replyValue}</Text>
                  </TableCol>
                </TableRow>
                <TableRow useFontBaseColor>
                  <TableCol colSpan={2} useFontBaseColor>
                    <Grid>
                      {item.documents.map((item, index) => {
                        return (
                          <Col width="33.3%" gutter={5} key={index}>
                            <Image src={item} />
                          </Col>
                        )
                      })}
                    </Grid>
                    <Text>{item.obs}</Text>
                  </TableCol>
                  <TableCol bgColor="#000" useFontBaseColor>
                    <Text color="#fff" semibold align="center">
                      {item.stringReply}
                    </Text>
                  </TableCol>
                </TableRow>
              </>
            )
          })}
          {item?.medidasProtecaoEletronica && !!item?.medidasProtecaoEletronica?.replies.length && (
            <TableRow useFontBaseColor>
              <TableCol colSpan={3} bgColor="#D9D9D9" useFontBaseColor>
                <Text semibold>ÍNDICE ALCANÇADO EM MEDIDAS DE PROTEÇÃO ELETRÔNICA</Text>
              </TableCol>
              <TableCol bgColor="#D9D9D9" useFontBaseColor>
                <Text semibold align="center">
                  {item?.medidasProtecaoEletronica?.result.toFixed(1)}
                </Text>
              </TableCol>
            </TableRow>
          )}

          {item?.medidasProtecaoHumana && !!item?.medidasProtecaoHumana?.replies.length && (
            <TableRow useFontBaseColor>
              <TableCol colSpan={3} bgColor="#000" useFontBaseColor>
                <Text color="#fff" semibold>
                  MEDIDAS DE PROTEÇÃO HUMANA
                </Text>
              </TableCol>
              <TableCol bgColor="#000" useFontBaseColor>
                <Text color="#fff" semibold align="center">
                  {item?.medidasProtecaoHumana?.totalValue}
                </Text>
              </TableCol>
            </TableRow>
          )}
          {item?.medidasProtecaoHumana?.replies.map((item, index) => {
            return (
              <>
                <TableRow useFontBaseColor>
                  <TableCol rowSpan={2} width="5%" useFontBaseColor>
                    <Text align="center">{item.questionNumber}</Text>
                  </TableCol>
                  <TableCol colSpan={2} useFontBaseColor>
                    <Text>{item.question}</Text>
                  </TableCol>
                  <TableCol useFontBaseColor>
                    <Text align="center">{item.replyValue}</Text>
                  </TableCol>
                </TableRow>
                <TableRow useFontBaseColor>
                  <TableCol colSpan={2} useFontBaseColor>
                    <Grid>
                      {item.documents.map((item, index) => {
                        return (
                          <Col width="33.3%" gutter={5} key={index}>
                            <Image src={item} />
                          </Col>
                        )
                      })}
                    </Grid>
                    <Text>{item.obs}</Text>
                  </TableCol>
                  <TableCol bgColor="#000" useFontBaseColor>
                    <Text color="#fff" semibold align="center">
                      {item.stringReply}
                    </Text>
                  </TableCol>
                </TableRow>
              </>
            )
          })}
          {item?.medidasProtecaoHumana && !!item?.medidasProtecaoHumana?.replies.length && (
            <TableRow useFontBaseColor>
              <TableCol colSpan={3} bgColor="#D9D9D9" useFontBaseColor>
                <Text semibold>ÍNDICE ALCANÇADO EM MEDIDAS DE PROTEÇÃO HUMANA</Text>
              </TableCol>
              <TableCol bgColor="#D9D9D9" useFontBaseColor>
                <Text semibold align="center">
                  {item?.medidasProtecaoHumana?.result.toFixed(1)}
                </Text>
              </TableCol>
            </TableRow>
          )}

          {item?.medidasProtecaoFisica && !!item?.medidasProtecaoFisica?.replies.length && (
            <TableRow useFontBaseColor>
              <TableCol colSpan={3} bgColor="#000" useFontBaseColor>
                <Text color="#fff" semibold>
                  MEDIDAS DE PROTEÇÃO FÍSICA
                </Text>
              </TableCol>
              <TableCol bgColor="#000" useFontBaseColor>
                <Text color="#fff" semibold align="center">
                  {item?.medidasProtecaoFisica?.totalValue}
                </Text>
              </TableCol>
            </TableRow>
          )}
          {item?.medidasProtecaoFisica?.replies.map((item, index) => {
            return (
              <>
                <TableRow useFontBaseColor>
                  <TableCol rowSpan={2} width="5%" useFontBaseColor>
                    <Text align="center">{item.questionNumber}</Text>
                  </TableCol>
                  <TableCol colSpan={2} useFontBaseColor>
                    <Text>{item.question}</Text>
                  </TableCol>
                  <TableCol useFontBaseColor>
                    <Text align="center">{item.replyValue}</Text>
                  </TableCol>
                </TableRow>
                <TableRow useFontBaseColor>
                  <TableCol colSpan={2} useFontBaseColor>
                    <Grid>
                      {item.documents.map((item, index) => {
                        return (
                          <Col width="33.3%" gutter={5} key={index}>
                            <Image src={item} />
                          </Col>
                        )
                      })}
                    </Grid>
                    <Text>{item.obs}</Text>
                  </TableCol>
                  <TableCol bgColor="#000" useFontBaseColor>
                    <Text color="#fff" semibold align="center">
                      {item.stringReply}
                    </Text>
                  </TableCol>
                </TableRow>
              </>
            )
          })}
          {item?.medidasProtecaoFisica && !!item?.medidasProtecaoFisica?.replies.length && (
            <TableRow useFontBaseColor>
              <TableCol colSpan={3} bgColor="#D9D9D9" useFontBaseColor>
                <Text semibold>ÍNDICE ALCANÇADO EM MEDIDAS DE PROTEÇÃO FÍSICA</Text>
              </TableCol>
              <TableCol bgColor="#D9D9D9" useFontBaseColor>
                <Text semibold align="center">
                  {item?.medidasProtecaoFisica?.result.toFixed(1)}
                </Text>
              </TableCol>
            </TableRow>
          )}

          {item?.medidasProtecaoOrganizativa && !!item?.medidasProtecaoOrganizativa?.replies.length && (
            <TableRow useFontBaseColor>
              <TableCol colSpan={3} bgColor="#000" useFontBaseColor>
                <Text color="#fff" semibold>
                  MEDIDAS DE PROTEÇÃO ORGANIZATIVA
                </Text>
              </TableCol>
              <TableCol bgColor="#000" useFontBaseColor>
                <Text color="#fff" semibold align="center">
                  {item?.medidasProtecaoOrganizativa?.totalValue}
                </Text>
              </TableCol>
            </TableRow>
          )}
          {item?.medidasProtecaoOrganizativa?.replies.map((item, index) => {
            return (
              <>
                <TableRow useFontBaseColor>
                  <TableCol rowSpan={2} width="5%" useFontBaseColor>
                    <Text align="center">{item.questionNumber}</Text>
                  </TableCol>
                  <TableCol colSpan={2} useFontBaseColor>
                    <Text>{item.question}</Text>
                  </TableCol>
                  <TableCol useFontBaseColor>
                    <Text align="center">{item.replyValue}</Text>
                  </TableCol>
                </TableRow>
                <TableRow useFontBaseColor>
                  <TableCol colSpan={2} useFontBaseColor>
                    <Grid>
                      {item.documents.map((item, index) => {
                        return (
                          <Col width="33.3%" gutter={5} key={index}>
                            <Image src={item} />
                          </Col>
                        )
                      })}
                    </Grid>
                    <Text>{item.obs}</Text>
                  </TableCol>
                  <TableCol bgColor="#000" useFontBaseColor>
                    <Text color="#fff" semibold align="center">
                      {item.stringReply}
                    </Text>
                  </TableCol>
                </TableRow>
              </>
            )
          })}
          {item?.medidasProtecaoOrganizativa && !!item?.medidasProtecaoOrganizativa?.replies.length && (
            <TableRow useFontBaseColor>
              <TableCol colSpan={3} bgColor="#D9D9D9" useFontBaseColor>
                <Text semibold>ÍNDICE ALCANÇADO EM MEDIDAS DE PROTEÇÃO ORGANIZATIVA</Text>
              </TableCol>
              <TableCol bgColor="#D9D9D9" useFontBaseColor>
                <Text semibold align="center">
                  {item?.medidasProtecaoOrganizativa?.result.toFixed(1)}
                </Text>
              </TableCol>
            </TableRow>
          )}

          {item?.prevencaoCombateIncendios && !!item?.prevencaoCombateIncendios?.replies.length && (
            <TableRow useFontBaseColor>
              <TableCol colSpan={3} bgColor="#000" useFontBaseColor>
                <Text color="#fff" semibold>
                  SISTEMA DE PREVENÇÃO E COMBATE A INCÊNDIOS
                </Text>
              </TableCol>
              <TableCol bgColor="#000" useFontBaseColor>
                <Text color="#fff" semibold align="center">
                  {item?.prevencaoCombateIncendios?.totalValue}
                </Text>
              </TableCol>
            </TableRow>
          )}
          {item?.prevencaoCombateIncendios?.replies.map((item, index) => {
            return (
              <>
                <TableRow useFontBaseColor>
                  <TableCol rowSpan={2} width="5%" useFontBaseColor>
                    <Text align="center">{item.questionNumber}</Text>
                  </TableCol>
                  <TableCol colSpan={2} useFontBaseColor>
                    <Text>{item.question}</Text>
                  </TableCol>
                  <TableCol useFontBaseColor>
                    <Text align="center">{item.replyValue}</Text>
                  </TableCol>
                </TableRow>
                <TableRow useFontBaseColor>
                  <TableCol colSpan={2} useFontBaseColor>
                    <Grid>
                      {item.documents.map((item, index) => {
                        return (
                          <Col width="33.3%" gutter={5} key={index}>
                            <Image src={item} />
                          </Col>
                        )
                      })}
                    </Grid>
                    <Text>{item.obs}</Text>
                  </TableCol>
                  <TableCol bgColor="#000" useFontBaseColor>
                    <Text color="#fff" semibold align="center">
                      {item.stringReply}
                    </Text>
                  </TableCol>
                </TableRow>
              </>
            )
          })}
          {item?.prevencaoCombateIncendios && !!item?.prevencaoCombateIncendios?.replies.length && (
            <TableRow useFontBaseColor>
              <TableCol colSpan={3} bgColor="#D9D9D9" useFontBaseColor>
                <Text semibold>ÍNDICE ALCANÇADO EM SISTEMA DE PREVENÇÃO E COMBATE A INCÊNDIOS</Text>
              </TableCol>
              <TableCol bgColor="#D9D9D9" useFontBaseColor>
                <Text semibold align="center">
                  {item?.prevencaoCombateIncendios?.result.toFixed(1)}
                </Text>
              </TableCol>
            </TableRow>
          )}

          {item?.processoAtendimentoEmergenciaMedica && !!item?.processoAtendimentoEmergenciaMedica?.replies.length && (
            <TableRow useFontBaseColor>
              <TableCol colSpan={3} bgColor="#000" useFontBaseColor>
                <Text color="#fff" semibold>
                  PROCESSO DE ATENDIMENTO A EMERGÊNCIA MÉDICA
                </Text>
              </TableCol>
              <TableCol bgColor="#000" useFontBaseColor>
                <Text color="#fff" semibold align="center">
                  {item?.processoAtendimentoEmergenciaMedica?.totalValue}
                </Text>
              </TableCol>
            </TableRow>
          )}
          {item?.processoAtendimentoEmergenciaMedica?.replies.map((item, index) => {
            return (
              <>
                <TableRow useFontBaseColor>
                  <TableCol rowSpan={2} width="5%" useFontBaseColor>
                    <Text align="center">{item.questionNumber}</Text>
                  </TableCol>
                  <TableCol colSpan={2} useFontBaseColor>
                    <Text>{item.question}</Text>
                  </TableCol>
                  <TableCol useFontBaseColor>
                    <Text align="center">{item.replyValue}</Text>
                  </TableCol>
                </TableRow>
                <TableRow useFontBaseColor>
                  <TableCol colSpan={2} useFontBaseColor>
                    <Grid>
                      {item.documents.map((item, index) => {
                        return (
                          <Col width="33.3%" gutter={5} key={index}>
                            <Image src={item} />
                          </Col>
                        )
                      })}
                    </Grid>
                    <Text>{item.obs}</Text>
                  </TableCol>
                  <TableCol bgColor="#000" useFontBaseColor>
                    <Text color="#fff" semibold align="center">
                      {item.stringReply}
                    </Text>
                  </TableCol>
                </TableRow>
              </>
            )
          })}
          {item?.processoAtendimentoEmergenciaMedica && !!item?.processoAtendimentoEmergenciaMedica?.replies.length && (
            <TableRow useFontBaseColor>
              <TableCol colSpan={3} bgColor="#D9D9D9" useFontBaseColor>
                <Text semibold>ÍNDICE ALCANÇADO EM PROCESSO DE ATENDIMENTO A EMERGÊNCIA MÉDICA</Text>
              </TableCol>
              <TableCol bgColor="#D9D9D9" useFontBaseColor>
                <Text semibold align="center">
                  {item?.processoAtendimentoEmergenciaMedica?.result.toFixed(1)}
                </Text>
              </TableCol>
            </TableRow>
          )}

          {item?.heliponto && !!item?.heliponto?.replies.length && (
            <TableRow useFontBaseColor>
              <TableCol colSpan={3} bgColor="#000" useFontBaseColor>
                <Text color="#fff" semibold>
                  HELIPONTO
                </Text>
              </TableCol>
              <TableCol bgColor="#000" useFontBaseColor>
                <Text color="#fff" semibold align="center">
                  {item?.heliponto?.totalValue}
                </Text>
              </TableCol>
            </TableRow>
          )}
          {item?.heliponto?.replies.map((item, index) => {
            return (
              <>
                <TableRow useFontBaseColor>
                  <TableCol rowSpan={2} width="5%" useFontBaseColor>
                    <Text align="center">{item.questionNumber}</Text>
                  </TableCol>
                  <TableCol colSpan={2} useFontBaseColor>
                    <Text>{item.question}</Text>
                  </TableCol>
                  <TableCol useFontBaseColor>
                    <Text align="center">{item.replyValue}</Text>
                  </TableCol>
                </TableRow>
                <TableRow useFontBaseColor>
                  <TableCol colSpan={2} useFontBaseColor>
                    <Grid>
                      {item.documents.map((item, index) => {
                        return (
                          <Col width="33.3%" gutter={5} key={index}>
                            <Image src={item} />
                          </Col>
                        )
                      })}
                    </Grid>
                    <Text>{item.obs}</Text>
                  </TableCol>
                  <TableCol bgColor="#000" useFontBaseColor>
                    <Text color="#fff" semibold align="center">
                      {item.stringReply}
                    </Text>
                  </TableCol>
                </TableRow>
              </>
            )
          })}
          {item?.heliponto && !!item?.heliponto?.replies.length && (
            <TableRow useFontBaseColor>
              <TableCol colSpan={3} bgColor="#D9D9D9" useFontBaseColor>
                <Text semibold>ÍNDICE ALCANÇADO EM SISTEMA DE HELIPONTO</Text>
              </TableCol>
              <TableCol bgColor="#D9D9D9" useFontBaseColor>
                <Text semibold align="center">
                  {item?.heliponto?.result.toFixed(1)}
                </Text>
              </TableCol>
            </TableRow>
          )}

          {item?.acessibilidade && !!item.acessibilidade?.replies.length && (
            <TableRow useFontBaseColor>
              <TableCol colSpan={3} bgColor="#000" useFontBaseColor>
                <Text color="#fff" semibold>
                  ACESSIBILIDADE
                </Text>
              </TableCol>
              <TableCol bgColor="#000" useFontBaseColor>
                <Text color="#fff" semibold align="center">
                  {item?.acessibilidade?.totalValue}
                </Text>
              </TableCol>
            </TableRow>
          )}
          {item?.acessibilidade?.replies.map((item, index) => {
            return (
              <>
                <TableRow useFontBaseColor>
                  <TableCol rowSpan={2} width="5%" useFontBaseColor>
                    <Text align="center">{item.questionNumber}</Text>
                  </TableCol>
                  <TableCol colSpan={2} useFontBaseColor>
                    <Text>{item.question}</Text>
                  </TableCol>
                  <TableCol useFontBaseColor>
                    <Text align="center">{item.replyValue}</Text>
                  </TableCol>
                </TableRow>
                <TableRow useFontBaseColor>
                  <TableCol colSpan={2} useFontBaseColor>
                    <Grid>
                      {item.documents.map((item, index) => {
                        return (
                          <Col width="33.3%" gutter={5} key={index}>
                            <Image src={item} />
                          </Col>
                        )
                      })}
                    </Grid>
                    <Text>{item.obs}</Text>
                  </TableCol>
                  <TableCol bgColor="#000" useFontBaseColor>
                    <Text color="#fff" semibold align="center">
                      {item.stringReply}
                    </Text>
                  </TableCol>
                </TableRow>
              </>
            )
          })}
          {item?.acessibilidade && !!item.acessibilidade?.replies.length && (
            <TableRow useFontBaseColor>
              <TableCol colSpan={3} bgColor="#D9D9D9" useFontBaseColor>
                <Text semibold>ÍNDICE ALCANÇADO EM ACESSIBILIDADE</Text>
              </TableCol>
              <TableCol bgColor="#D9D9D9" useFontBaseColor>
                <Text semibold align="center">
                  {item?.acessibilidade?.result.toFixed(1)}
                </Text>
              </TableCol>
            </TableRow>
          )}
        </Table>
      </Col>
      <Separator weight={10} />
    </View>
  )
}

export default AvalAndares
